import styled from 'styled-components';
import { palette } from '@dev/ee-components';

type StyledProps = {
    disableTopMargin?: boolean;
    mt?: number;
    isMobile?: boolean;
};

export const HeaderContainer = styled.div<StyledProps>`
    margin-bottom: ${({ disableTopMargin }): number => (disableTopMargin ? 0 : 32)}px;
    & > div {
        display: flex;
        align-items: center;
    }
`;

export const ScreenContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    & .MuiAlert-root {
        margin: 24px 0;
        color: ${palette.gray[7]};
    }
    & .MuiRadio-root {
        padding: 2px 9px;
    }
`;

export const AlertWrapper = styled.div<StyledProps>`
    margin: ${({ isMobile }): string => !isMobile && '0 48px'};
    > div {
        margin: ${({ isMobile }): string => isMobile && '16px 0 32px 0'};
    }
`;
export const IconWrapper = styled.div`
    background: ${palette.basic.paper};
    border: 1px solid ${palette.indigo[6]};
    border-radius: 4px;
    height: 44px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SearchWrapper = styled.div<StyledProps>`
    display: ${({ isMobile }): string => isMobile && 'flex'};
`;

export const ContactHeaders = styled.div<StyledProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: ${({ isMobile }): string => (isMobile ? 'column' : 'row')};
    padding: ${({ isMobile }): string => (isMobile ? '0' : '24px 48px')};
    & > div {
        min-width: ${({ isMobile }): string => (isMobile ? '100%' : '25%')};
    }
    .fullScreen {
        width: 100%;
    }
`;

export const RuleWrapper = styled.div<StyledProps>`
    ${({ isMobile }): string =>
        isMobile &&
        `
        background: white;
        padding: 20px 32px;
        border: 1px solid #E2E8F0;
        border-radius: 4px;
        margin-bottom: 32px;
    `}
`;

export const MobileTableWrapper = styled.div`
    margin-top: 32px;
    & .MuiContainer-root.MuiContainer-maxWidthLg {
        padding: 0 20px;
    }
    & .infinite-scroll-component {
        overflow: initial !important;
    }
`;

export const FilterContainer = styled.div`
    padding: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const FilterLabel = styled.span`
    margin: 0;
    & + .MuiChip-root {
        margin-left: 12px;
    }
`;

export const FilterIconContainer = styled.div`
    cursor: pointer !important;
    & > * {
        fill: ${palette.gray[5]} !important;
    }
`;

export const ArrowDropdownContainer = styled.div`
    svg {
        margin-bottom: -4px;
    }
`;

export const HeaderTitle = styled.div`
    & .MuiBox-root {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;
